export const getItemFromStorage = (keyName :string) => {
  const store = localStorage.getItem(keyName);
  if (store) {
    return JSON.parse(store);
  }
  return '';
};

export default null;
